import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  Chip,
} from "@mui/material";

const FlavorTagsSection = ({
  formData,
  setFormData,
  dietaryTags,
  allergens,
}) => {
  return (
    <>
      <FormControl fullWidth margin="dense">
        <InputLabel>Dietary Tags</InputLabel>
        <Select
          multiple
          value={(formData.dietaryTags || []).map((d) => d._id)}
          onChange={(e) => {
            const selectedIds = e.target.value;
            const selectedTags = dietaryTags.filter((tag) =>
              selectedIds.includes(tag._id)
            );
            setFormData({ ...formData, dietaryTags: selectedTags });
          }}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((id) => {
                const tag = dietaryTags.find((d) => d._id === id);
                return tag ? <Chip key={id} label={tag.label} /> : null;
              })}
            </Box>
          )}>
          {dietaryTags.map((tag) => (
            <MenuItem key={tag._id} value={tag._id}>
              <Checkbox
                checked={(formData.dietaryTags || []).some(
                  (d) => d._id === tag._id
                )}
              />
              <ListItemText primary={tag.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="dense">
        <InputLabel>Allergens</InputLabel>
        <Select
          multiple
          value={(formData.allergens || []).map((a) => a._id)}
          onChange={(e) => {
            const selectedIds = e.target.value;
            const selectedAllergens = allergens.filter((a) =>
              selectedIds.includes(a._id)
            );
            setFormData({ ...formData, allergens: selectedAllergens });
          }}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((id) => {
                const allergen = allergens.find((a) => a._id === id);
                return allergen ? (
                  <Chip key={id} label={allergen.name} />
                ) : null;
              })}
            </Box>
          )}>
          {allergens.map((a) => (
            <MenuItem key={a._id} value={a._id}>
              <Checkbox
                checked={(formData.allergens || []).some(
                  (al) => al._id === a._id
                )}
              />
              <ListItemText primary={a.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default FlavorTagsSection;
